<template>

    <div class="container-center">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img
                    src="data:image/png;base64,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">
                <p><span class="title">{{ detailData.materialEnterName || '甲供材料进场通知单发起' }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                        {{ detailData.nodeName && (`（当前审批节点：${detailData.nodeName}）`) }}
                    </span>
                </p>
                <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span>
            </div>

            <!-- 材料列表 -->
            <label v-if="pageType!=0" class="fade-title">甲供材料进场通知单编号：{{ detailData.materialEnterNo }}</label>

            <!-- 添加材料 -->
            <div
                v-if="pageType==0 || detailData.approveStatus == 0 || detailData.approveStatus == 1 || detailData.approveStatus == 4"
                class="text-right" style="padding-bottom:20px;float:right;">
                <el-button @click="addMeterialDialog = true;resetForm();" type="primary" size="mini">添加材料</el-button>
            </div>

            <el-table :data="detailData.dhsConMaterialEnterDetailList||[]" size="mini" border stripe>
                <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                <el-table-column align="center" label="名称品牌" prop="">
                    <template slot-scope="scope">
                        <span>{{ allMaterial.matchAt('fid', scope.row.brand, 'fnameL2') }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="140" label="主体栋号" prop="">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.buildnumberList || []).joinAt('fnameL2',',') }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="140" label="规格型号" prop="model"></el-table-column>
                <el-table-column align="center" width="140" label="技术参数" prop="parameter"></el-table-column>
                <el-table-column align="center" width="140" label="数量" prop="amount"></el-table-column>
                <el-table-column align="center" width="140" label="进场时间" prop="enterDate"></el-table-column>
                <el-table-column align="center" width="140" label="操作">
                    <template slot-scope="scope">
                        <a @click="getMeterial(scope.row.id)">查看</a>
                        <a v-if="detailData.approveStatus!=2 && detailData.approveStatus!=3"
                           @click="setMeterial(scope.row.id)">编辑</a>
                        <a v-if="detailData.approveStatus!=2 && detailData.approveStatus!=3"
                           @click="delMeterial(scope.row.id)">删除</a>
                    </template>
                </el-table-column>
            </el-table>

            <div class="text-center" style="padding:30px 0;">
                <el-button @click="$router.push($root.navs[1].path)" type="" size="medium" icon="el-icon-back">返回合同台账
                </el-button>
                <el-button
                    v-if="pageType==0 || detailData.approveStatus == 0 || detailData.approveStatus == 1 || detailData.approveStatus == 4"
                    @click="submitMeterial" type="primary" size="medium">提交申请
                </el-button>
            </div>


            <!-- 分隔线 -->
            <div v-if="pageType!=0" class="fade-line"></div>


            <!-- 审批记录 -->
            <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审批意见" prop="approveRemark"></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate"></el-table-column>
                </el-table>
            </div>

        </el-card>


        <!-- 添加、编辑 材料 -->
        <el-dialog :title="(setMeterialMode ? '修改' : '添加') +'材料信息'" :visible.sync="addMeterialDialog" width="800px"
                   @close="resetForm" center>

            <el-form label-width="160px" ref="form" :model="form" :rules="rules" size="mini">

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称品牌：" prop="brand">
                            <el-select v-model="form.brand" style="width:100%;">
                                <el-option v-for="li in allMaterial" :label="li.fnameL2" :value="li.fid"
                                           :key="li.fid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="技术参数：" prop="parameter">
                            <el-input v-model="form.parameter" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="主体栋号：" v-bind:prop="allBuildingNumber.length==0?'':'buildingIds'">
                            <el-input v-if="allBuildingNumber.length==0" value="暂无" disabled></el-input>
                            <el-select v-else v-model="form.buildingIds" multiple placeholder="请选择" style="width:100%;">
                                <el-option v-for="o in allBuildingNumber" :label="o.fnameL2" :value="o.fid"
                                           :key="o.fid"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="规格型号：" prop="model">
                            <el-input v-model="form.model" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="数量：" prop="amount">
                            <el-col :span="14">
                                <el-input v-model.number="form.amount" clearable></el-input>
                            </el-col>
                            <el-col :span="9" :offset="1">
                                <el-select v-model="form.unitId" placeholder="单位">
                                    <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                               :key="o.fid"></el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="进场时间：" prop="enterDate">
                            <el-date-picker v-model="form.enterDate" type="date" format="yyyy-MM-dd" placeholder="选择日期"
                                            size="mini" style="width:100%;"
                                            value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="备注：" prop="">
                            <el-input v-model="form.remark" type="textarea" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-form-item label="图集：" prop="">
                    <el-upload
                        class="upload-demo"
                        multiple
                        :limit="20"
                        :action="uploadApi"
                        :file-list="form.baseFileList"
                        :on-success="handleAdd" :on-error="uploadError"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemove"
                    >
                        <el-button size="small" type="primary">上 传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="addMeterialDialog = false">取 消</el-button>
                <el-button type="primary" @click="setMeterial_" v-if="setMeterialMode">修 改</el-button>
                <el-button type="primary" @click="addMeterial" v-else>保 存</el-button>
            </span>

        </el-dialog>


        <!-- 查看材料 -->
        <el-dialog title="材料信息" :visible.sync="meterialDataDialog" width="720px" @close="resetForm" center>

            <div class="detail-dialog">
                <el-row>
                    <el-col :span="5" class="text-right">名称品牌：</el-col>
                    <el-col :span="7">{{ allMaterials['no'+ form.brand] || '无' }}</el-col>
                    <el-col :span="5" class="text-right">规格型号：</el-col>
                    <el-col :span="7">{{ form.model || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">技术参数：</el-col>
                    <el-col :span="7">{{ form.parameter || '无' }}</el-col>
                    <el-col :span="5" class="text-right">数量：</el-col>
                    <el-col :span="7">
                        {{ form.amount || '无' }} {{ allUnits['no'+ form.unitId] }}
                    </el-col>
                </el-row>
                <!--<el-row>
                    <el-col :span="5" class="text-right">供应商：</el-col><el-col :span="7">{{ form.supplierName || '无' }}</el-col>
                    <el-col :span="5" class="text-right">单位地址：</el-col><el-col :span="7">{{ form.address || '无' }}</el-col>
                </el-row>-->
                <el-row>
                    <el-col :span="5" class="text-right">主体栋号：</el-col>
                    <el-col :span="7">{{ (form.buildnumberList || []).joinAt('fnameL2',',') || '无' }}</el-col>
                    <el-col :span="5" class="text-right">进场时间：</el-col>
                    <el-col :span="7">{{ form.enterDate || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">备注：</el-col>
                    <el-col :span="7">{{ form.remark || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">附件：</el-col>
                    <el-col :span="19">
                        <div v-if="!form.baseFileList || form.baseFileList && form.baseFileList.length==0"
                             class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in form.baseFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                                target="_blank">{{ li.fileOldName }}</a>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>


        </el-dialog>


    </div><!-- container-center -->

</template>

<script type="text/babel">
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'

    export default {
        name: 'contract-detail',
        data() {
            return {

                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                baseStatus: ['草稿', '待审批', '审批中', '审批通过', '审批不通过'],

                allMaterial: [],
                allMaterials: {},
                allUnit: [],
                allUnits: {},
                allBuildingNumber: [],
                allBuildingNumbers: {},

                // 表单验证
                rules: {
                    brand: [
                        {required: true, message: '必填'},
                    ],
                    amount: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    model: [
                        {required: true, message: '必填'},
                    ],
                    parameter: [
                        {required: true, message: '必填'},
                    ],
                    buildingIds: [
                        {required: true, message: '必填'},
                    ],
                    enterDate: [
                        {required: true, message: '必填'}
                    ],
                },

                // 页面类型 0: 发起,带billId;  1: 查看,带msgId
                pageType: this.$route.params.type,

                // 发起后返回的 ID
                createId: '',

                // 详情数据
                detailData: {
                    dhsConPricingDetailList: []
                },

                // 添加材料
                addMeterialDialog: false,
                form: {
                    brand: '',
                    parameter: '',
                    buildingIds: [],
                    buildnumberList: [],
                    model: '',
                    amount: '',
                    unitId: '',
                    enterDate: '',
                    remark: '',
                    baseFileList: []
                },
                setMeterialMode: false,
                setMeterialId: '',

                // 已有材料信息
                meterialDataDialog: false,
            }
        },
        methods: {

            // 上传文件格式验证
            beforeUpload(file) {

                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'});
            },


            // 配置信息
            getAllMaterial() {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getAllMaterial', {}).then((res) => {

                    loading.close()

                    if (res.data.result) {
                        this.allMaterial = res.data.value
                        this.allMaterial.forEach((data, index) => {
                            this.allMaterials['no' + data.fid] = data.fnameL2;
                        })
                    } else {
                        this.$message({message: 'Error: 材料名称获取失败', type: 'error'})
                    }
                })
            },
            getAllUnit() {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getAllUnit', {}).then((res) => {

                    loading.close()

                    if (res.data.result) {
                        this.allUnit = res.data.value

                        this.allUnit.forEach((data, index) => {
                            this.allUnits['no' + data.fid] = data.fnameL2;
                        })

                    } else {
                        this.$message({message: 'Error: 单位获取失败', type: 'error'})
                    }
                })
            },
            getAllBuildingNumber() {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getAllBuildingNumber', {}).then((res) => {

                    loading.close()

                    if (res.data.result) {
                        this.allBuildingNumber = res.data.value

                        this.allBuildingNumber.forEach((data, index) => {
                            this.allBuildingNumbers['no' + data.fid] = data.fnameL2;
                        })

                    } else {
                        this.$message({message: 'Error: 楼栋获取失败', type: 'error'})
                    }
                })
            },

            // pageType: 0 发起
            createMaterialEnter() {
                this.$http.post('rest/api/contract/createMaterialEnter', {
                    contractBillId: this.$route.params.id
                }).then((res) => {
                    if (res.data.result) {
                        // this.$message({message: '请添加材料', type: 'success'})

                        this.createId = res.data.value.id

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.$route.params.id)
                        }, {name: '发起'}]

                    } else {
                        this.$message({message: 'Error: 发起', type: 'error'})
                    }
                })
            },

            // pageType: 0|1 获取详情
            getDetailData() {
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/MaterialEnterInfo', {
                    msgId: this.$route.params.id
                }).then((res) => {
                    loading.close();
                    if (res.data.result) {
                        this.detailData = res.data.value;

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.detailData.contractBillId)
                        }, {name: '详情'}]

                    } else {
                        this.$message({message: 'Error: 获取详情', type: 'error'})
                    }
                })
            },

            resetForm() {

                this.form = {
                    brand: '',
                    parameter: '',
                    buildingIds: [],
                    buildnumberList: [],
                    model: '',
                    amount: '',
                    unitId: '',
                    enterDate: '',
                    remark: '',
                    baseFileList: []
                }
                this.setMeterialMode = false

                this.$refs['form'] && this.$refs['form'].clearValidate()

                this.allUnit[0] && (this.form.unitId = this.allUnit[0].fid)
            },

            handleRemove: function (file, fileList) {
                this.form.baseFileList = this.form.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                });
            },
            handleAdd: function (response, file, fileList) {
                // if(file.status=='success'){
                this.form.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },

            // pageType: 0|1 添加材料
            addMeterial() {

                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                        this.$http.post('rest/api/contract/createMaterialEnterDetail',
                            Object.assign(
                                {
                                    materialEnterId: (this.$route.params.type == 0 ? this.createId : this.$route.params.id),
                                    // id: (this.$route.params.type==0 ? this.$route.params.id : this.detailData.contractBillId ),
                                },
                                this.form
                            )
                        ).then((res) => {

                            // loading.close()
                            this.addMeterialDialog = false;

                            if (res.data.result) {
                                this.$message({message: '材料添加成功', type: 'success'})

                                if (this.pageType == 0) {  // 初次发起跳往详情
                                    this.$router.push('/ContractDetail01/1/' + this.createId + '/' + encodeURIComponent(this.$route.params.name))
                                    setTimeout(function () {
                                        location.reload()
                                    }, 1000)
                                } else {
                                    this.getDetailData()  // 获取最新信息
                                }

                            } else {
                                this.$message({message: 'Error: 材料添加失败', type: 'error'})
                            }
                        })

                    } else {
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false;
                    }

                });
            },

            // 查看材料
            getMeterial(id) {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getMaterialEnterDetail', {
                    msgId: id
                }).then((res) => {

                    loading.close()

                    if (res.data.result) {
                        this.form = res.data.value
                        this.form.buildingIds = []
                        this.meterialDataDialog = true
                    } else {
                        this.$message({message: 'Error: 材料信息获取失败', type: 'error'})
                    }
                })
            },

            // 显示修改表单
            setMeterial(id) {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getMaterialEnterDetail', {
                    msgId: id
                }).then((res) => {

                    loading.close()

                    if (res.data.result) {
                        this.form = res.data.value

                        this.form.baseFileList.forEach(function (data) {
                            data.name = data.fileOldName
                        })

                        this.form.buildingIds = []
                        this.form.buildnumberList.forEach((data, index) => {
                            this.form.buildingIds.push(data.fid);
                        })

                        this.setMeterialMode = true
                        this.setMeterialId = id

                        this.addMeterialDialog = true
                    } else {
                        this.$message({message: 'Error: 材料信息获取失败', type: 'error'})
                    }
                })
            },

            // 真正修改请求
            setMeterial_() {

                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                        this.$http.post('rest/api/contract/updateMaterialEnterDetail',
                            Object.assign(
                                {
                                    // contractBillId: this.detailData.contractBillId,
                                    // pricingId: this.$route.params.id,
                                    id: this.setMeterialId
                                },
                                this.form
                            )
                        ).then((res) => {

                            loading.close()
                            this.addMeterialDialog = false;

                            if (res.data.result) {
                                this.$message({message: '材料修改成功', type: 'success'})

                                this.getDetailData()  // 获取最新列表

                            } else {
                                this.$message({message: 'Error: 材料修改失败', type: 'error'})
                            }
                        })

                    } else {
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false;
                    }

                });
            },

            delMeterial(id) {
                this.$confirm('确定要删除材料吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    const loading = this.$loading({background: 'rgba(255,255,255,0.5)'});
                    this.$http.post('rest/api/contract/deleteMaterialEnterDetail', {
                        msgId: id
                    }).then((res) => {
                        loading.close()

                        if (res.data.result) {
                            this.$message({message: '删除成功', type: 'success'})
                            this.getDetailData()  // 获取最新列表
                        } else {
                            this.$message({message: '删除失败：' + res.data.message, type: 'error'})
                        }
                    })
                });
            },

            // 提交申请
            submitMeterial() {

                if (this.detailData.dhsConMaterialEnterDetailList.length == 0) {
                    this.$message({message: '请先添加材料', type: 'error'})
                    return
                }

                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/postMaterialEnter', {
                    id: this.$route.params.id,
                    contractBillId: this.detailData.contractBillId,
                }).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.$message({message: '提交成功', type: 'success'})
                        setTimeout(function () {
                            location.reload()
                        }, 1000)
                    } else {
                        this.$message({message: '提交失败：' + res.data.message, type: 'error'})
                    }
                })

            },
        },
        created() {
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []
        },
        mounted() {

            // dev test
            window.ji = this;


            // 获取配置信息
            this.getAllMaterial()
            this.getAllUnit()
            this.getAllBuildingNumber()

            // 0: 发起 带billId;  1: 查看 带msgId
            if (this.pageType == 0) {
                this.createMaterialEnter()
            } else {
                this.getDetailData()
            }

            util.toTop()

        }
    }

    function __getBaseFiles__(file, fileList) {
        let fs = [];
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0];
                item.bizTableName = f.biztablename;
                item.bizTablePkName = f.biztablepkname;
                item.bizTablePkValue = f.biztablepkvalue;
                item.fid = f.fid;
                item.fileCatagoryId = f.filecatagoryid;
                item.fileDesc = f.filedesc;
                item.fileOldName = f.fileoldname;
                item.name = f.fileoldname;
                item.fileName = f.filename;
                item.filePath = f.filepath;
                item.fileSize = f.filesize;
                item.fileType = f.filetype;
                item.sort = f.sort;
            }
            fs.push(item);
        });
        console.log(fs);
        return fs
    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';


    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-dialog {
        padding: 20px 0;
    }

    .detail-dialog .el-row {
        line-height: 32px;
    }

    .detail-dialog .text-right {
        color: var(--cTxt3);
    }


</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail01.vue